if (!customElements.get('variant-sku')) {
  class VariantSku extends HTMLElement {
    connectedCallback() {
      this._handler = this.onVariantChange.bind(this);
      document.addEventListener('variant:change', this._handler);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this._handler);
    }

    onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;

      const eventFormId = event.detail.formId;
      if (eventFormId) {
        const ownForm = this.closest('form');
        if (ownForm && ownForm.id && ownForm.id !== eventFormId) return;
      }

      const sku = variant.sku || '';
      const label = this.dataset.label || '';

      if (!sku) {
        this.hidden = true;
        return;
      }

      this.hidden = false;
      this.textContent = label ? `${label} ${sku}` : sku;
    }
  }

  customElements.define('variant-sku', VariantSku);
}
